import ApplicationReports from "./ApplicationReports";

const DraftApplications = () => {
  return(
    <ApplicationReports status="3" title="District Draft Applications Report" heading="Draft Applications"></ApplicationReports>
  )
};

export default DraftApplications;
